module.exports = "/_next/static/fonts/ShadowsIntoLight-Regular-ea525bb49984279f2e0fd21bba21c026.woff2";